import React, {useRef, useState} from "react";
import NavBar from "../components/NavBar/NavBar";
import Footer from "../components/Footer/Footer";
import emailjs from "emailjs-com";
import '../sass/_contact.scss';

const Contact = () => { 
    const form = useRef();
    const [responseMessage, setResponseMessage] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(
            "service_8b0n8s1",
            "template_59uiugl",
            form.current,
            "xlUTk7SHXYRc4EAnn"
        )
        .then(
            (result) => {
                setResponseMessage("Votre message a été envoyé avec succès !")
                form.current.reset();
                //console.log("Message envoyé avec succès:", result.text)
                //alert("Message envoyé avec succès !")
            }, 
            (error) => {
                setResponseMessage("Une erreur est survenue. Veuillez réessayer.")
                //console.log("Erreur:", error.text);
                //alert("Une erreur est survenue, veuillez réessayer.")
            }
        )
    }
    return (
        <>
        <NavBar/>
        <section className="contact">
            
            <form className="contact_form" ref={form} onSubmit={sendEmail}>{responseMessage && (
                <p
                className={`response-message ${
                    responseMessage.includes("erreur") ? "error" : "success"
                }`}
            >
                {responseMessage}
            </p>
            )}
                <h2>Contactez Moi</h2>
                <div className="input-box">
                    <label htmlFor="">Nom</label>
                    <input type="text" className="field" name="from_name" placeholder="Votre nom" required/>
                </div>
                <div className="input-box">
                    <label htmlFor="">Email</label>
                    <input type="email" className="field" name="reply_to" placeholder="Votre email" required/>
                </div>
                <div className="input-box">
                    <label htmlFor="">Votre message</label>
                    <textarea name="message" className="field mess" placeholder="Votre message" required></textarea>
                </div>
                <button type="submit">Envoyez votre message</button>
            </form>
        </section>
        <Footer/>
        </>
    )
}

export default Contact;